module.exports = __webpack_public_path__ + "img/enter-reservation.e955cba2.svg";